<template>
  <div class="print-break-after measures-sheet-container">
    <!-- 
      Div principale
    -->
    <div v-show="tabToShow === 'default'" class="wg-row">
      <div class="wg-row input-row">
        <div class="wg-col wg-xs-6">
          <div style="font-size:17px;" class="com-anm22-app-text-m suit-model">
            {{ $anm22.strLang(lang, "Model", "Modello") }}
          </div>
        </div>
        <div class="wg-col wg-xs-6">
          <select
            v-if="mode === 'edit'"
            class="input-elem com-anm22-app-select"
            v-model="sheetData.modelName"
          >
            <option
              v-for="(model, index) in modelsList"
              :key="'model-' + index"
              :value="model.modelName"
              >{{ model.modelName }}</option
            >
          </select>
          <span class="input-text com-anm22-app-text-m" v-else>{{
            modelSelected.modelName
          }}</span>
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;">&nbsp;</div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Top base size", "Taglia base sopra") }}
            </div>
            <select
              class="input-elem com-anm22-app-select"
              :disabled="!(mode === 'edit')"
              v-model="sheetData.sizeTop"
            >
              <option
                v-for="(model, index) in sizesList"
                :key="'modelsizeTop-' + index"
                :value="model.size"
                >{{ model.size }}</option
              >
            </select>
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">
              {{
                $anm22.strLang(lang, "Bottom base size", "Taglia base sotto")
              }}
            </div>
            <select
              class="input-elem com-anm22-app-select"
              v-model="sheetData.sizeBottom"
            >
              <option
                v-for="(model, index) in sizesList"
                :key="'modelsizeBottom-' + index"
                :value="model.size"
                :disabled="!(mode === 'edit')"
                >{{ model.size }}</option
              >
            </select>
          </div>
        </div>
      </div>
      <div class="wg-row input-row" style="height:36px;">
        <div class="wg-col wg-xs-3">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Fit", "Vestibilità") }}
          </div>
        </div>
        <div class="wg-col wg-xs-9">
          <div class="wg-row" style="align-items:center;">
            <input
              :disabled="mode === 'view'"
              id="fit-r"
              type="radio"
              value="racingPro"
              style="display:none;"
              v-model="measures.fit"
            />
            <label class="label-input-radio" for="fit-r">{{
              measures.fit === "racingPro" ? "✔" : ""
            }}</label>
            <div class="com-anm22-app-text-m" style="margin:0 5px;">
              {{ $anm22.strLang(lang, "Racing", "Racing") }}
            </div>
            <div class="com-anm22-horizontal-div" style="width: 20px;"></div>
            <input
              :disabled="mode === 'view'"
              id="fit-s"
              type="radio"
              value="sport"
              style="display:none;"
              v-model="measures.fit"
            />
            <label class="label-input-radio" for="fit-s">{{
              measures.fit === "sport" || measures.fit === "racing" ? "✔" : ""
            }}</label>
            <div class="com-anm22-app-text-m" style="margin:0 5px;">
              {{ $anm22.strLang(lang, "Sport", "Sport") }}
            </div>
            <div class="com-anm22-horizontal-div" style="width: 20px;"></div>
            <input
              :disabled="mode === 'view'"
              id="fit-c"
              type="radio"
              value="roomy"
              style="display:none;"
              v-model="measures.fit"
            />
            <label class="label-input-radio" for="fit-c">{{
              measures.fit === "roomy" || measures.fit === "comfort" ? "✔" : ""
            }}</label>
            <div class="com-anm22-app-text-m" style="margin:0 5px;">
              {{ $anm22.strLang(lang, "Roomy", "Roomy") }}
            </div>
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;">&nbsp;</div>
      <div
        style="height:36px;position:relative;padding-left:125px;"
        class="wg-row"
      >
        <div
          class="wg-col wg-xs-2"
          style="position:relative;width:14.28%;"
          v-for="(label, index) in labels"
          :key="'label' + index"
        >
          <div
            style="text-overflow:ellipsis;overflow:hidden;white-space:wrap;"
            class="com-anm22-app-text-m"
            :title="label.labelName"
          >
            {{ label.labelName }}
          </div>
        </div>
      </div>
      <div class="wg-row">
        <div
          class="wg-row input-row measure"
          v-for="(input, index) in fields"
          :key="'input' + index"
        >
          <div class="wg-col wg-xs-1" style="min-width:20px; max-width:20px">
            <div class="com-anm22-app-text-m">{{ index + 1 }}</div>
          </div>
          <div
            class="wg-col"
            style="width: 100%; min-width:100px; max-width:100px; overflow: hidden;"
          >
            <div
              style="overflow-wrap:break-word;"
              class="input-text com-anm22-app-text-m print-text"
            >
              {{ input.label }}
            </div>
          </div>
          <div class="wg-col wg-xs-2">
            <input
              v-if="input.name == 'manica-piegata-totale'"
              disabled
              class="input-elem print-elem com-anm22-app-input-text"
              type="text"
              v-model="sommaManicaPiegataTot"
            />
            <input
              v-else
              disabled
              class="input-elem print-elem com-anm22-app-input-text"
              type="text"
              v-model="measures[input.name]"
            />
          </div>

          <div class="com-anm22-horizontal-div" style="width: 2px;"></div>
          <div class="wg-col wg-xs-2">
            <input
              class="input-elem print-elem com-anm22-app-input-text"
              type="text"
              :placeholder="measures[input.name]"
              v-model="sheetData.rMeasures[input.name]"
            />
          </div>
          <div class="com-anm22-horizontal-div" style="width: 2px;"></div>
          <div class="wg-col wg-xs-2">
            <input
              :disabled="mode === 'view'"
              class="input-elem print-elem com-anm22-app-input-text"
              type="number"
              :placeholder="defaultFits[input.name]"
              v-model="vestib[input.name]"
            />
          </div>
          <div class="com-anm22-horizontal-div" style="width:2px;"></div>
          <div class="wg-col wg-xs-2">
            <input
              class="input-elem print-elem com-anm22-app-input-text"
              type="text"
              disabled
              :value="totalMeasures(input.name)"
            />
          </div>
          <div class="com-anm22-horizontal-div" style="width: 2px;"></div>
          <div class="wg-col wg-xs-2">
            <input
              class="input-elem print-elem com-anm22-app-input-text"
              type="text"
              v-model="sheetData.paperPattern[input.name]"
            />
          </div>
          <div class="com-anm22-horizontal-div" style="width: 2px;"></div>
          <div class="wg-col wg-xs-2">
            <input
              disabled
              :value="getSizeColVal[input.base][input.name]"
              class="input-elem print-elem com-anm22-app-input-text"
              type="text"
            />
          </div>
          <div class="com-anm22-horizontal-div" style="width: 2px;"></div>
          <div class="wg-col wg-xs-2">
            <input
              disabled
              :value="differenceSize(input.name)"
              class="input-elem print-elem com-anm22-app-input-text"
              type="number"
            />
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:40px;">&nbsp;</div>
      <div class="wg-row input-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Last edit", "Ultima modifica") }}
          </div>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ lastEditDate + " " + lastEditUser }}
          </div>
        </div>
      </div>
      <template v-if="mode === 'edit'">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <input
            type="button"
            :value="$anm22.strLang(lang, 'Save', 'Salva')"
            @click="saveForm"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    projectId: [Number, String],
    docs: Object,
    sizes: Array,
    mode: {
      type: String,
      default: "edit",
    },
  },
  data() {
    return {
      // Misure
      measures: {},
      //Scheda con i vari dati(salviamo solo la vestibilità e il modello selezionato ,gli altri dati sono dati derivati)
      sheetData: {
        sizeSelected: "",
        sizeSelectedTop: "",
        sizeSelectedBottom: "",
        vestibility: {},
        rMeasures: {},
        paperPattern: {},
      },
      vestib: {},
      modelSelected: {
        modelSizes: null,
        fits: {
          racing: {},
          sport: {},
          roomy: {},
        },
      },
      modelSelectedTop: {
        modelSizes: {},
        fits: null,
      },
      modelSelectedBottom: {
        modelSizes: {},
        fits: null,
      },
      tabToShow: "default",
      picToShow: null,
      labels: [
        {
          labelName: this.$anm22.strLang(
            this.lang,
            "Misure rilevate",
            "Measures taken"
          ),
        },
        {
          labelName: this.$anm22.strLang(
            this.lang,
            "Misure riproporzionate",
            "Re-proportioned measures"
          ),
        },
        {
          labelName: this.$anm22.strLang(
            this.lang,
            "Vestibilità",
            "Vestibility"
          ),
        },
        {
          labelName: this.$anm22.strLang(this.lang, "Totale", "Total"),
        },
        {
          labelName: this.$anm22.strLang(
            this.lang,
            "Carta modello",
            "Paper pattern"
          ),
        },
        {
          labelName: this.$anm22.strLang(this.lang, "Taglie", "Sizes"),
        },
        {
          labelName: this.$anm22.strLang(this.lang, "Diff", "Diff"),
        },
      ],
      fields: [
        {
          name: "punto-spalla",
          label: "Punto spalle",
          base: "top",
        },
        {
          name: "circ-torace",
          label: "Circonferenza torace",
          base: "top",
        },
        {
          name: "circ-vita",
          label: "Circonferenza vita",
          base: "top",
        },
        {
          name: "circ-bacino",
          label: "Circonferenza bacino",
          base: "bottom",
        },
        {
          name: "da-pv-a-ginocchio",
          label: "Da punto vita a centro ginocchio",
          base: "bottom",
        },
        {
          name: "da-pv-a-caviglia",
          label: "Da punto vita a caviglia",
          base: "bottom",
        },
        {
          name: "da-pv-a-terra",
          label: "Da punto vita a terra",
          base: "bottom",
        },
        {
          name: "manica-spalla-gomito",
          label: "Lunghezza manica da spalla a centro gomito",
          base: "top",
        },
        {
          name: "manica-gomito-fondo",
          label: "Lunghezza manica da centro gomito a fondo",
          base: "top",
        },
        {
          name: "circ-braccio",
          label: "Circonferenza braccio",
          base: "top",
        },
        {
          name: "circ-avanbraccio",
          label: "Circonferenza avanbraccio",
          base: "top",
        },
        {
          name: "circ-polso",
          label: "Circonferenza polso",
          base: "top",
        },
        {
          name: "circ-coscia",
          label: "Circonferenza coscia",
          base: "bottom",
        },
        {
          name: "circ-ginocchio",
          label: "Circonferenza ginocchio",
          base: "bottom",
        },
        {
          name: "circ-polpaccio",
          label: "Circonferenza polpaccio",
          base: "bottom",
        },
        {
          name: "circ-caviglia",
          label: "Circonferenza caviglia",
          base: "bottom",
        },
        {
          name: "lung-vita",
          label: "Lunghezza vita",
          base: "top",
        },
        {
          name: "altezza",
          label: "Altezza cm",
          base: "top",
        },
        {
          name: "peso",
          label: "Peso kg",
          base: "top",
        },
        {
          name: "manica-piegata-totale",
          label: "10+9 lunghezza manica piegata totale",
          base: "top",
        },
        {
          name: "ovetto",
          label: "Ovetto",
          base: "bottom",
        },
        {
          name: "punto-seno",
          label: "Punto seno (donna)",
          base: "top",
        },
        {
          name: "dist-seni",
          label: "Distanza seni (donna)",
          base: "top",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
    }),
    sommaManicaPiegataTot() {
      if (
        !this.measures["manica-spalla-gomito"] &&
        this.measures["manica-gomito-fondo"]
      ) {
        return this.measures["manica-gomito-fondo"];
      } else if (
        this.measures["manica-spalla-gomito"] &&
        !this.measures["manica-gomito-fondo"]
      ) {
        return this.measures["manica-spalla-gomito"];
      } else if (
        !this.measures["manica-spalla-gomito"] &&
        !this.measures["manica-gomito-fondo"]
      ) {
        return;
      }
      return (
        Number(this.measures["manica-spalla-gomito"]) +
        Number(this.measures["manica-gomito-fondo"])
      );
    },
    project() {
      return this.$store.getters["projects/get"]([this.projectId]);
    },
    lastEditUser() {
      const user = this.$store.getters["users/get"](this.sheetData.lastUser);
      return user ? user.name + " " + user.surname : "";
    },
    lastEditDate() {
      return this.sheetData.lastUpdate
        ? this.$moment
            .unix(this.sheetData.lastUpdate)
            .format("DD/MM/YYYY HH:mm")
        : "";
    },
    modelsList() {
      return this.sizes
        .filter((item) => !item.size)
        .sort((a, b) => a.modelName.localeCompare(b.modelName));
    },
    sizesList() {
      return this.sizes
        .filter(
          (item) => item.modelName === this.sheetData.modelName && item.size
        )
        .sort((a, b) => a.size - b.size);
    },
    getSizeColVal() {
      const sizes = {};
      if (!this.modelSelectedTop.modelSizes) {
        sizes.top = {};
      } else {
        sizes.top = this.modelSelectedTop.modelSizes;
      }

      if (!this.modelSelectedTop.modelSizes) {
        sizes.bottom = {};
      } else {
        sizes.bottom = this.modelSelectedBottom.modelSizes;
      }

      return sizes;
    },
    defaultFits() {
      if (
        !this.modelSelected ||
        !this.modelSelected.fits ||
        !this.measures.fit
      ) {
        return {};
      }
      const measureFitKey = this.getMeasureFitKeyByFit(this.measures.fit);

      if (!measureFitKey || !this.modelSelected.fits[measureFitKey]) {
        return {};
      }

      return this.modelSelected.fits[measureFitKey];
    },
  },
  watch: {
    "sheetData.modelName": function(newVal) {
      this.updateSelectedBaseModels();
    },
    "sheetData.sizeTop": function(newVal) {
      this.updateSelectedBaseModels();
    },
    "sheetData.sizeBottom": function(newVal) {
      this.updateSelectedBaseModels();
    },
  },
  methods: {
    saveForm() {
      const docs = { ...this.docs };
      this.applyDefaultFitValues();
      docs.measuresSheet = this.sheetData;
      docs.measuresSheet.lastUser = this.user.idWorldUser;
      docs.measuresSheet.lastUpdate = this.$moment().unix();
      this.$emit("save", docs);
      this.$anm22.eventBus.$emit("wg-modal-close");
    },
    //Totale tra misura e vestibilità
    totalMeasures(input) {
      let measure;
      let vestibility = Number(this.getAppliedFit(input));
      if (input == "manica-piegata-totale") {
        if (this.sheetData.rMeasures[input]) {
          measure = Number(this.sheetData.rMeasures[input]);
        } else {
          measure = this.sommaManicaPiegataTot;
        }
      } else if (this.sheetData.rMeasures[input]) {
        measure = Number(this.sheetData.rMeasures[input]);
      } else {
        measure = Number(this.measures[input]);
      }
      if (!vestibility && measure) {
        return measure;
      } else if (!measure) {
        return "";
      } else if (measure && vestibility) {
        let tot = measure + vestibility;
        return Math.round(tot * 10) / 10;
      }
    },
    //Differenza tra totale e taglia
    differenceSize(input) {
      const basePart = this.getMeausureBasePart(input);

      if (!this.getSizeColVal[basePart][input]) {
        return "";
      }
      let size = Number(this.getSizeColVal[basePart][input]);
      let total = this.totalMeasures(input);
      if (!size) {
        return 0;
      } else {
        let diff = total - size;
        return Math.round(diff * 10) / 10;
      }
    },
    applyDefaultFitValues() {
      if (this.modelSelected && this.measures.fit) {
        const measureFitKey = this.getMeasureFitKeyByFit(this.measures.fit);
        if (measureFitKey && this.modelSelected.fits[measureFitKey]) {
          this.fields.forEach((element) => {
            if (
              (typeof this.sheetData.vestibility[element.name] == undefined ||
                this.sheetData.vestibility[element.name] == "") &&
              this.modelSelected.fits[measureFitKey][element.name]
            ) {
              this.sheetData.vestibility[
                element.name
              ] = this.modelSelected.fits[measureFitKey][element.name];
            }
          });
        }
      }
    },
    getMeausureBasePart(measureId) {
      const measureSpec = this.fields.find((el) => el.name === measureId);
      if (measureSpec) {
        return measureSpec.base;
      }
      return "top";
    },
    getAppliedFit(measureId) {
      if (this.vestib[measureId]) {
        return this.vestib[measureId];
      }
      if (this.defaultFits[measureId]) {
        return this.defaultFits[measureId];
      }
      return 0;
    },
    updateSelectedBaseModels() {
      const modelBase = this.sizes.filter(
        (item) => item.modelName == this.sheetData.modelName && !item.size
      );
      if (modelBase.length > 0) {
        this.modelSelected = modelBase[0];
      } else {
        this.modelSelected = {
          fits: {
            racing: {},
            sport: {},
            roomy: {},
          },
        };
      }
      const modelTopBase = this.sizes.filter(
        (item) =>
          item.modelName == this.sheetData.modelName &&
          item.size == this.sheetData.sizeTop
      );
      if (modelTopBase.length > 0) {
        this.modelSelectedTop = modelTopBase[0];
      } else {
        this.modelSelectedTop = {
          modelSizes: {},
        };
      }
      const modelBottomBase = this.sizes.filter(
        (item) =>
          item.modelName == this.sheetData.modelName &&
          item.size == this.sheetData.sizeBottom
      );
      if (modelBottomBase.length > 0) {
        this.modelSelectedBottom = modelBottomBase[0];
      } else {
        this.modelSelectedBottom = {
          modelSizes: {},
        };
      }
    },
    getMeasureFitKeyByFit(fit) {
      switch (fit) {
        case "racingPro":
          return "racing";
        case "racing":
        case "sport":
          return "sport";
        case "roomy":
        case "comfort":
          return "roomy";
        default:
          return null;
      }
    },
  },
  created() {
    this.measures = { ...this.docs.measures };
    this.sheetData = { ...this.docs.measuresSheet };
    if (!this.sheetData.rMeasures) {
      this.sheetData.rMeasures = {};
    }
    if (!this.sheetData.paperPattern) {
      this.sheetData.paperPattern = {};
    }
    //creo l'oggetto vestibility in caso non sia presente
    if (!this.sheetData.vestibility || this.sheetData.vestibility.length == 0) {
      this.sheetData.vestibility = {};
    }
    this.vestib = this.sheetData.vestibility;

    // Size retro
    if (
      this.sheetData.sizeSelected &&
      !this.sheetData.modelName &&
      !this.sheetData.sizeTop &&
      !this.sheetData.sizeBottom
    ) {
      const oldModelBases = this.sizes.filter(
        (item) => item.idVircosModelsBase == this.sheetData.sizeSelected
      );
      if (oldModelBases.length > 0) {
        const oldModelBase = oldModelBases[0];
        this.sheetData.modelName = oldModelBase.modelName;
        this.sheetData.sizeTop = oldModelBase.size;
        this.sheetData.sizeBottom = oldModelBase.size;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.input-row {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  margin-bottom: 10px;
}
.input-text {
  padding-left: 10px;
}
.input-elem {
  width: 100%;
  max-width: 200px;
}
.label-input-radio {
  display: block;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
.pic-viewer {
  height: calc(90vh - 90px);
  width: 100%;
  justify-content: center;
}
@media print {
  .input-row.measure {
    margin: 0;
    height: 28px;
    input {
      height: 28px;
      padding: 5px 10px;
    }
  }
  .print-break-after {
    break-after: page;
  }
}
</style>
